// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_6w-0";